/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Error_Description2Inputs */

const en_settings_reportingapikeys_error_description2 = /** @type {(inputs: Settings_Reportingapikeys_Error_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your session may have expired or you may be missing the required permission. Refresh the page or sign in again.`)
};

/**
* | output |
* | --- |
* | "Your session may have expired or you may be missing the required permission. Refresh the page or sign in again." |
*
* @param {Settings_Reportingapikeys_Error_Description2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_error_description2 = /** @type {((inputs?: Settings_Reportingapikeys_Error_Description2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Error_Description2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_error_description2(inputs)
});
export { settings_reportingapikeys_error_description2 as "settings_reportingApiKeys_error_description" }